const passengerBoxMessages = {
    validationErrorMessages: {
        firstNameRequired:"First name is needed.",
        lastNameRequired:"Last name is needed.",
        titleNotSpecified:"Please specify title.",
        invalidBirthday:"Invalid birthday date.",
        invalidBirthdayCnn:"Invalid birthday date of a child passenger.",
        invalidBirthdayInf:"Invalid birthday date of an infant passenger.",
        phoneNoRequired:"Phone number is needed.",
        emailRequired:"Email is needed.",
        contactPhoneNoRequired:"Contact phone number is needed.",
        contactNameRequired:"Contact name is needed.",
        contactEmailRequired:"Contact email is needed.",
    },
   
};

export default passengerBoxMessages;